import React from 'react'
import classnames from 'classnames'
import { inject, observer } from 'mobx-react'
import MarkerLayer from './MarkerLayer'

// Renders a marker which has been saved by the user
// and retreived from the server
const SavedMarkerLayer = ({
  marker, group, selectionStore, uiStore
}) => {
  const isEditingThisMarker = selectionStore.isEditing && selectionStore.editableShape && (
    selectionStore.editableShape === marker ||
    (marker.id != null && selectionStore.editableShape.id != null && String(marker.id) === String(selectionStore.editableShape.id))
  )

  const handleDragEnd = (latLng) => {
    if (isEditingThisMarker && latLng) {
      marker.position.latLng = latLng
    }
  }

  return marker.position && marker.visible
    ? (
      <MarkerLayer
        marker={marker}
        draggable={isEditingThisMarker}
        onDragEnd={handleDragEnd}
        onClick={(e) => {
          marker.openPopup(e)
          // Focus through the selection observer only when the marker changes.
          selectionStore.clearSelectedMenuItems()
          selectionStore.addSelectedMenuItem(marker)
          selectionStore.select(marker, { data: { group } })
          group.expanded = true
        }}
        className={classnames({
          geopolygon: true,
          highlighted: marker.highlighted,
          'leaflet-interactive': true,
          'hidden-name': marker.hideName,
          selected: (
            (selectionStore.item === group) ||
            (selectionStore.item === marker) ||
            isEditingThisMarker
          )
        })}
      />
      )
    : null
}

export default inject('selectionStore')(
  observer(SavedMarkerLayer)
)
